import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertNoPermission from "../../alerts/AlertNoPermission";

class CharacterStatuses extends Component {
    state = { characterStatusesList: [], noPermission: false };

    getCharacterStatuses = async () => {
        const { fetchURL, defaultValue, onShowAlert, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/character-statuses`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "character/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const charStatuses = fetchedData.charStatuses;
                        if (defaultValue === "all") {
                            charStatuses.push({
                                key: charStatuses.length + 1,
                                value: "all",
                                text: t("selectAll"),
                            });
                        }

                        this.setState({ characterStatusesList: charStatuses });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getCharacterStatuses();
    }

    render() {
        const { characterStatusesList, noPermission } = this.state;
        const { value, onChangeValue, req, t } = this.props;
        return (
            <Fragment>
                <Form.Label>
                    {t("characters.charStatuses")} {req && <span className="required">*</span>}
                </Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : (
                    <Dropdown
                        value={value}
                        id="charStatDropdown"
                        className={req ? "req mb-3" : "mb-3"}
                        placeholder={t("characters.clickToChooseStatus")}
                        fluid
                        selection
                        options={characterStatusesList}
                        onChange={(event, { value }) => {
                            document.getElementById("charStatDropdown").classList.remove("danger");
                            onChangeValue(value);
                        }}
                    />
                )}
            </Fragment>
        );
    }
}

export default CharacterStatuses;
